import { useEffect, useState, useRef } from 'react';
import { Send, MessageCircle } from 'lucide-react';
import { adminApi, fmtDate } from '../../lib/api';

export default function Messages() {
  const [threads, setThreads] = useState([]);
  const [active, setActive] = useState(null);
  const [msgs, setMsgs] = useState([]);
  const [body, setBody] = useState('');
  const scrollRef = useRef();

  const loadThreads = () => adminApi.get('/admin/messages/threads').then((r) => setThreads(r.data));
  useEffect(() => { loadThreads(); const t = setInterval(loadThreads, 15000); return () => clearInterval(t); }, []);

  useEffect(() => {
    if (active) adminApi.get(`/admin/messages/${active.customer_id}`).then((r) => setMsgs(r.data));
  }, [active]);

  useEffect(() => { scrollRef.current?.scrollTo({ top: 99999, behavior: 'smooth' }); }, [msgs]);

  const send = async () => {
    if (!body.trim() || !active) return;
    await adminApi.post(`/admin/messages/${active.customer_id}`, { body });
    setBody('');
    const r = await adminApi.get(`/admin/messages/${active.customer_id}`);
    setMsgs(r.data);
    loadThreads();
  };

  return (
    <div className="fade-in" data-testid="messages-page">
      <h1 className="text-3xl font-semibold mb-4">Messages</h1>
      <div className="card grid grid-cols-1 md:grid-cols-3 min-h-[600px] overflow-hidden">
        {/* Threads */}
        <div className="border-r border-[#f3f3f3] overflow-y-auto max-h-[600px]">
          {threads.length === 0 && <div className="p-10 text-center text-sm text-[#6b7280]"><MessageCircle size={24} className="mx-auto mb-2" />No messages yet</div>}
          {threads.map((t) => (
            <button
              key={t.customer_id}
              onClick={() => setActive(t)}
              className={`w-full text-left px-4 py-3 border-b border-[#f3f3f3] hover:bg-[#fafafa] ${active?.customer_id === t.customer_id ? 'bg-[#fafafa]' : ''}`}
              data-testid={`thread-${t.customer_id}`}
            >
              <div className="flex items-center justify-between">
                <div className="font-semibold text-sm truncate">{t.customer_name}</div>
                {t.unread > 0 && <span className="bg-[#d92027] text-white text-[10px] px-1.5 rounded-full font-bold">{t.unread}</span>}
              </div>
              <div className="text-xs text-[#6b7280] truncate mt-0.5">{t.last_sender === 'admin' ? 'You: ' : ''}{t.last_message}</div>
              <div className="text-[10px] text-[#6b7280] mt-0.5">{fmtDate(t.last_time)}</div>
            </button>
          ))}
        </div>
        {/* Chat */}
        <div className="md:col-span-2 flex flex-col max-h-[600px]">
          {active ? (
            <>
              <div className="p-4 border-b border-[#f3f3f3]">
                <div className="font-semibold">{active.customer_name}</div>
                <div className="text-xs text-[#6b7280]">{active.customer_email}</div>
              </div>
              <div ref={scrollRef} className="flex-1 p-4 overflow-y-auto space-y-3 bg-[#fafafa]">
                {msgs.map((m) => (
                  <div key={m.message_id} className={`flex ${m.sender === 'admin' ? 'justify-end' : 'justify-start'}`}>
                    <div className={`max-w-[75%] p-3 rounded-2xl ${m.sender === 'admin' ? 'bg-[#d92027] text-white' : 'bg-white border border-[#e7e7e7]'}`}>
                      <div className="text-sm whitespace-pre-wrap">{m.body}</div>
                      <div className={`text-[10px] mt-1 ${m.sender === 'admin' ? 'text-white/70' : 'text-[#6b7280]'}`}>{fmtDate(m.created_at)}</div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="p-3 border-t border-[#f3f3f3] flex gap-2">
                <input
                  value={body}
                  onChange={(e) => setBody(e.target.value)}
                  onKeyDown={(e) => e.key === 'Enter' && !e.shiftKey && (e.preventDefault(), send())}
                  placeholder="Type your reply..."
                  className="flex-1 px-3 py-2 border border-[#e7e7e7] rounded-lg text-sm"
                  data-testid="admin-message-input"
                />
                <button onClick={send} className="btn-brand flex items-center gap-1" data-testid="admin-send-message"><Send size={14} /></button>
              </div>
            </>
          ) : (
            <div className="flex-1 flex items-center justify-center text-sm text-[#6b7280]">Select a conversation</div>
          )}
        </div>
      </div>
    </div>
  );
}
